"use client";

import type { ButtonHTMLAttributes } from "react";

import { setDialog } from "@/components/app/dialogs/dialog-provider";
import { useBackgroundPathname } from "@/hooks/use-background-pathname";
import { DIALOG } from "@/utils/dialog-routes";
import { cn } from "@/utils/lib";

interface FeedbackWidgetProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  customCurrentPage?: string;
}

export default function FeedbackWidget({
  children,
  className,
  customCurrentPage = "",
  onClick,
  type = "button",
  ...props
}: FeedbackWidgetProps) {
  const pathname = useBackgroundPathname();
  const currentPage = customCurrentPage || pathname || "";

  const openFeedbackDialog = () => {
    setDialog(DIALOG.Feedback, {
      open: true,
      params: currentPage ? { currentPage } : {},
    });
  };

  return (
    <button
      type={type}
      className={cn("text-left", className)}
      onClick={(event) => {
        onClick?.(event);

        if (!event.defaultPrevented) {
          openFeedbackDialog();
        }
      }}
      {...props}
    >
      {children}
    </button>
  );
}
